var resourceType = document.getElementById('resourceType');
var dropdowns = document.querySelectorAll('select');
var searchButton = document.getElementById('resourceSearch');

var clearButton = document.getElementById('resourceSearchClear');

if (searchButton != null) {
    searchButton.addEventListener('click', function (e) {
        location.reload();
    });
}
if (clearButton != null) {
    clearButton.addEventListener('click', function (e) {
        window.history.replaceState({}, '', window.location.pathname);
        location.reload();
    });
}
dropdowns.forEach(function (el) {
    console.log("EL: %o", el.id);
    el.addEventListener('change', function (e) {
        console.log(`Value = ${e.target.value}`);

        var params = new URLSearchParams(window.location.search);

        e.target.value != "Select" ? params.set(el.id, e.target.value) : params.delete(el.id);

        var sparam = '' + params;
        if (sparam !== '') {
            window.history.replaceState({}, '', window.location.pathname + '?' + params);
        } else {
            window.history.replaceState({}, '', window.location.pathname);
        }
    });
});